/**
 * 求人フィルタータブ（.topJobs__filterBtn）
 */
export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	const $filterBtns = $('.topJobs__filterBtn');
	if (!$filterBtns.length) return;
	$filterBtns.on('click', function () {
		const filter = $(this).data('filter');
		$filterBtns.removeClass('is-active');
		$(this).addClass('is-active');
		if (filter === 'all') {
			$('.topJobs__item').show();
		} else {
			$('.topJobs__item').hide().filter("[data-type='" + filter + "']").show();
		}
	});
}
